export default "__VITE_ASSET__C7m5wOuh__"